import(/* webpackMode: "eager" */ "/vercel/path0/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/src/app/signup/auth-bg-light.png");
;
import(/* webpackMode: "eager", webpackExports: ["LoginButton"] */ "/vercel/path0/app/src/app/signup/LoginButton.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/src/app/signup/style.scss");
;
import(/* webpackMode: "eager", webpackExports: ["ModeToggle"] */ "/vercel/path0/app/src/components/ModeToggle/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/src/hooks/useWindowSize.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/src/utils/sessionProvider.tsx");
